import React from 'react';
import { NotificationBadge } from 'src/legacy/components/UI/Badges';
import { useGetNotificationsSettingsQuery } from 'src/services/api/notificationsSettingsApi';
import { useAppSelector } from 'src/hooks/useStore';

export const MessagesNotificationBadge = () => {
  const isClientUser = useAppSelector((state) => state.user.isClient);
  const totalUnreadMessages = useAppSelector(
    (state) => state.messages.totalUnreadMessages,
  );
  const { data: notificationSettings } = useGetNotificationsSettingsQuery(
    undefined,
    {
      skip: isClientUser,
    },
  );
  const disabledProductNotification = notificationSettings?.disableInProduct;
  const disableMessagesNotifications =
    notificationSettings?.notifyAbout.newMessages.disableInProduct;

  if (
    disabledProductNotification ||
    disableMessagesNotifications ||
    totalUnreadMessages === 0
  )
    return null;

  return (
    <NotificationBadge
      htmlId="messages-notification-badge"
      isSidebar
      showZero={false}
      content={totalUnreadMessages || 0}
    />
  );
};
